class ListItemHighlight {
  _list;

  constructor(list) {
    this.list = list;
  }

  getNewList(data, highlight) {
    let newList = [];
    const exists = this.list.some((item) => data.id === item.id);

    if (exists) {
      newList = this.list.map((item) => {
        if (item.id === data.id) {
          item = {
            ...item,
            ...data,
            highlight,
          };
        }

        return item;
      });
    } else {
      const created = {
        ...data,
        highlight,
      };

      newList = [created].concat(this.list);
    }

    return newList;
  }
}

export default ListItemHighlight;
